import styled from 'styled-components';
import { useTranslate } from '@agilepoint/wat-react';
import { StackPanel, Typography, typographyPresets } from '@agilepoint/wat-react-ux';
import { ReactComponent as NotFoundIllustration } from '../../../assets/svg/route-not-found-illustration.svg';

export interface INotFoundPageProps {
    className?: string;
}

export interface INotFoundPageProps {
    className?: string;
}

const MainHeaderInfo = styled.div`
    ${typographyPresets.headings.h1};
    font-size: 40px;
    font-weight: 400;
`;

export function NotFoundPage(props: INotFoundPageProps) {
    const { className } = props;
    const translate = useTranslate();

    return (
        <StackPanel className={className} orientation="horizontal" width="100%" height="100%" justifyContent="center" alignment="center" gap="30">
            <NotFoundIllustration />
            <StackPanel orientation="vertical" gap="30">
                <MainHeaderInfo>Oops!</MainHeaderInfo>
                <Typography.H4>{translate('common.messages.pageDoesNotExists')}</Typography.H4>
            </StackPanel>
        </StackPanel>
    );
}
